/* eslint-disable */
const cn = require('json-loader!yaml-loader!./zh-CN.yml')
const en = require('json-loader!yaml-loader!./en-US.yml')

export default {
  'zh-CN': cn,
  'en-US': en
}
